import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import asiaMarketLogo from '../assets/images/Asiamarket.png';
import { fetchAndStoreUserRole, verifyAdminAccessWithToken, loginOperator } from '../utils/auth';

const LoginPage = () => {
  const [operatorName, setOperatorName] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleOperatorLogin = async () => {
    if (!operatorName || !password) {
      alert('Please enter both username and password.');
      return;
    }

    try {
      // Autentica no endpoint que grava o token num cookie httpOnly (o JS
      // nao ve o token). Guarda so a flag de sessao + o nome do operador.
      await loginOperator(operatorName, password);
      localStorage.removeItem('roleName');
      localStorage.removeItem('roleNameKey');
      localStorage.removeItem('roleId');
      localStorage.removeItem('roleCheck');
      try {
        sessionStorage.removeItem('adminPanelAccessUser');
        sessionStorage.removeItem('adminPanelAccessVersion');
      } catch {
        // ignore
      }

      console.debug('Attempting role fetch after login…');
      await fetchAndStoreUserRole();
      await verifyAdminAccessWithToken(operatorName);

      window.dispatchEvent(new Event('auth-changed'));
      navigate('/order-list');
    } catch (error) {
      alert('Authentication failed. Please check your credentials.');
      console.error('Error during login:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img className="login-logo" src={asiaMarketLogo} alt="Asia Market" />
        <h2>Login</h2>
        <form onSubmit={(e) => { e.preventDefault(); handleOperatorLogin(); }}>
          <input
            className="login-input"
            type="text"
            placeholder="Username"
            value={operatorName}
            onChange={(e) => setOperatorName(e.target.value)}
          />
          <input
            className="login-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button className="login-button" type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
